import { render, staticRenderFns } from "./widget_edit.vue?vue&type=template&id=4a341e8c&scoped=true&"
import script from "./widget_edit.vue?vue&type=script&lang=js&"
export * from "./widget_edit.vue?vue&type=script&lang=js&"
import style0 from "./widget_edit.vue?vue&type=style&index=0&id=4a341e8c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a341e8c",
  null
  
)

/* custom blocks */
import block0 from "@/lang/table?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fwidgets%2Felements%2Fwidget_edit.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/actions?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fwidgets%2Felements%2Fwidget_edit.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/lang/rules?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fwidgets%2Felements%2Fwidget_edit.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports